import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}users`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}users/${id}`);
  return response;
};

const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}users`, payload);
  return response;
};

const update = async (id, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}users/${id}`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}users/${id}`);
  return response;
};

export { getAll, getById, insert, update, drop };
